import { setObjects } from '../helpers';

const initialState = () => ({
    storage: {
    },
})

const mutations = {
    ADD_PROGRESS (state, progress) {
        setObjects(progress, state.storage, { primarySubmissions: [], feedback: [], diligence: null, badge: null })
    },
    ADD_PRIMARY_SUBMISSION_TO_PROGRESS (state, progressId, submissionId) {
        state.storage[progressId].primarySubmissions.push(submissionId)
    },
    REMOVE_PRIMARY_SUBMISSION_FROM_PROGRESS (state, progressId, submissionId) {
        const index = state.storage[progressId].primarySubmissions.indexOf(submissionId)
        state.storage[progressId].primarySubmissions.splice(index, 1)
    },
    ADD_FEEDBACK_TO_PROGRESS (state, progressId, feedbackId) {
        state.storage[progressId].feedback = [feedbackId]
    },
    ADD_DILIGENCE_TO_PROGRESS (state, progressId, diligenceId) {
        state.storage[progressId].diligence = [diligenceId]
    },
    ADD_BADGE_TO_PROGRESS (state, progressId, badgeId) {
        state.storage[progressId].badge = [badgeId]
    },
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/progress.js